<!--
 * @Descripttion: 单据详情
-->
<template>
  <div>
    <el-drawer
      title="单据详情"
      :visible.sync="drawerVisible"
      size="480px"
      direction="rtl"
      :before-close="handleClose"
      class="order-detail-drawer"
    >
      <div class="drawer-content">
        <!-- 基本信息卡片 -->
        <el-card class="info-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-document"></i>
            <span>基本信息</span>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">单据编号</span>
              <span class="info-value copy-value" @click="handleCopy(orderInfo.bizId)" title="点击复制">
                <span class="copy-text">{{ orderInfo.bizId || '-' }}</span>
                <i v-if="orderInfo.bizId" class="el-icon-document-copy copy-icon"></i>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">发货日期</span>
              <span class="info-value">{{ orderInfo.specifyDeliveryDate ? parseTime(orderInfo.specifyDeliveryDate, '{y}-{m}-{d}') : '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">业务类型</span>
              <span class="info-value">
                <span v-if="orderInfo.used !== '其他出库业务'">{{ orderInfo.used || '-' }}</span>
                <dict-tag v-else :options="dictObj.bizType" :value="orderInfo.qtType" />
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">申请部门</span>
              <span class="info-value">{{ orderInfo.applyOrgName || '-' }}</span>
            </div>
          </div>
        </el-card>

        <!-- 收件人信息卡片 -->
        <el-card class="info-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-location-information"></i>
            <span>收件人信息</span>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">客户名称</span>
              <span class="info-value">{{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customer : '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">客户</span>
              <span class="info-value">{{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerName : '-' }}</span>
            </div>
            <div class="info-item full-width">
              <span class="info-label">收件人区域</span>
              <span class="info-value">{{ area || '-' }}</span>
            </div>
            <div class="info-item full-width">
              <span class="info-label">详细地址</span>
              <span class="info-value address-value">{{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerAddress : '-' }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">联系电话</span>
              <span class="info-value">{{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerTelephone : '-' }}</span>
            </div>
          </div>
        </el-card>

        <!-- 备注卡片 -->
        <el-card v-if="orderInfo.remark" class="info-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-info"></i>
            <span>备注</span>
          </div>
          <div class="remark-content">
            {{ orderInfo.remark }}
          </div>
        </el-card>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getOrderInfo } from '@/api/orderManage'
import { getDict } from '@/api/common'
import { parseTime } from '@/utils/ruoyi'

export default {
  data() {
    return {
      drawerVisible: false,
      orderInfo: {
        recipientInfoVo: {}
      },
      dictObj: {
        bizType: []
      }
    }
  },
  computed: {
    area() {
      const { recipientInfoVo: { consigneeProvinceName = '', consigneeCityName = '', consigneeCountyName = '' } } = this.orderInfo
      return `${consigneeProvinceName}${consigneeCityName ? `/${consigneeCityName}` : ''}${consigneeCountyName ? `/${consigneeCountyName}` : ''}`
    }
  },
  methods: {
    parseTime,
    open({ orderId }) {
      this.drawerVisible = true
      this.getOrderInfo({ orderId })
    },
    handleClose() {
      this.drawerVisible = false
      this.orderInfo = { recipientInfoVo: {} }
    },
    getOrderInfo({ orderId }) {
      this.getDicts(['bizType'])
      this.$emit('changeParentLoading', true)
      getOrderInfo(orderId).then(res => {
        this.orderInfo = res.data || {}
      }).finally(() => {
        this.$emit('changeParentLoading', false)
      })
    },
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
        })
      })
    },
    handleCopy(text) {
      if (!text) return
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.drawer-content {
  padding: 16px;
}

.info-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #EBEEF5;

  ::v-deep .el-card__header {
    padding: 12px 16px;
    background-color: #F5F7FA;
    border-bottom: 1px solid #EBEEF5;
  }

  ::v-deep .el-card__body {
    padding: 16px;
  }
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #303133;

  i {
    margin-right: 8px;
    color: #409EFF;
    font-size: 16px;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &.full-width {
    grid-column: 1 / -1;
  }
}

.info-label {
  font-size: 13px;
  color: #909399;
  line-height: 1.4;
}

.info-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  line-height: 1.4;
}

.address-value {
  word-break: break-all;
}

.remark-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  padding: 4px 0;
}

.copy-value {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #F5F7FA;

    .copy-text {
      color: #409EFF;
    }

    .copy-icon {
      color: #409EFF;
    }
  }
}

.copy-text {
  transition: color 0.2s;
}

.copy-icon {
  color: #C0C4CC;
  font-size: 14px;
  transition: color 0.2s;
}
</style>
